import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=7b9ed07f"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports